export { AppliRole, LevelRole } from './appli-role';
export { PartialEntity } from './partial-entity';
export { PartialUser } from './partial-user';
